'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/grid/style/css.js
// module id = b7fF
// module chunks = 0